import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import { Button, Stack, Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import { useTenantTranslation } from "hooks/formatters";

interface TimelineZoomCaptionProps {
  visibleStart: Dayjs;
  visibleEnd: Dayjs;
  timeFormat: string;
  zoomFactor: number;
  onResetZoom: () => void;
}

export const TimelineZoomCaption = ({
  visibleStart,
  visibleEnd,
  timeFormat,
  zoomFactor,
  onResetZoom,
}: TimelineZoomCaptionProps) => {
  const { t } = useTenantTranslation();

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="caption" color="text.secondary">
        {visibleStart.utc().format(timeFormat)}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="caption" color="text.secondary">
          {`×${zoomFactor.toFixed(1)}`}
        </Typography>
        <Button
          size="small"
          variant="text"
          startIcon={<ZoomOutMapIcon fontSize="small" />}
          onClick={onResetZoom}
        >
          {t("resetZoom")}
        </Button>
      </Stack>
      <Typography variant="caption" color="text.secondary">
        {visibleEnd.utc().format(timeFormat)}
      </Typography>
    </Stack>
  );
};
